// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ocglU","footer":"Form_footer__1b5jD"};